(ns practitest.frontend.page
  (:require
   [goog.object :as gobj]
   [practitest.frontend.batch-modal.main :as batch-modal]
   [practitest.frontend.common.keyboard-shortcuts :as keyboard-shortcuts]
   [practitest.frontend.common.re-frame :refer [partial-dispatch]]
   [practitest.frontend.components.license-blocked-modal :as license-modal]
   [practitest.frontend.components.navigation :as navigation]
   [practitest.frontend.components.account-layout.account-layout :as account-layout]
   [practitest.frontend.components.project-assistant :as project-assistant]
   [practitest.frontend.components.notifications :as notifications]
   [practitest.frontend.components.view-editor :as view-editor]
   [practitest.frontend.components2.components-provider :refer [application-provider]]
   [practitest.frontend.events :as events]
   [practitest.frontend.find-and-replace-modal.main :as find-and-replace-modal]
   [practitest.frontend.init :as init]
   [practitest.frontend.routing.router :as router]
   [practitest.frontend.subs :as subs]
   [practitest.frontend.version-updates.views :as version-updates]
   [practitest.frontend.impersonation :as impersonation]
   [re-frame.core :as re-frame]
   [reagent.dom :as rdom]))

(def ^:private unauthenticated-routes #{:login :login-password :forgot-password :reset-password :no-project :oauth-authorization :user-link-result :user-without-project :permission-error :signup-new :signup-edit})

(defn navigation-layout
  [body options]
  (let [new-account-settings? (navigation/account-setting-path?)]
    [:<>
     [notifications/toast-container]
     (cond
       new-account-settings?
       [:div.main-window2
        [account-layout/account-settings-header (assoc options :webcomponent? true :account-settings? true) navigation/header-bar-buttons]
        [navigation/system-messages-bar (assoc options :current-user-account (some #(when (= (:id (:account %)) (:id (:current-account options))) %) (:user-accounts options)))]
        [:div.menu-and-body-container2
         [account-layout/account-settings-panel (assoc options :webcomponent? true)]
         [:div.main-body2 body]]]

       :else
       (let [assistant-available? (project-assistant/assistant-available?)]
         [:div.main-window2
          [navigation/header-bar (assoc options :assistant-shell? assistant-available?)]
          [navigation/system-messages-bar
           (assoc options :current-user-account
                  (some #(when (= (:id (:account %)) (:id (:current-account options))) %) (:user-accounts options)))]
          [:div.menu-and-body-container2
           [navigation/project-level-menu options]
           (if assistant-available?
             [project-assistant/body-with-assistant body]
             [:div.main-body2 body])]]))]))

;; TODO: cleanup, move to navigation ?
(defn main-view []
  (let [current-route @(re-frame/subscribe [::router/current-route])
        route-name    (get-in current-route [:data :name])]
    (if (contains? unauthenticated-routes route-name)
      ;; Login / forgot-password: no nav chrome
      [application-provider
       ^{:key (str route-name)} [router/get-view current-route]]
      ;; Authenticated app: full navigation
      (let [options         @(re-frame/subscribe [::subs/options])
            user-projects   @(re-frame/subscribe [::subs/user-projects])
            user-accounts   @(re-frame/subscribe [::subs/user-accounts])
            current-project @(re-frame/subscribe [::subs/current-project])
            current-user    @(re-frame/subscribe [::subs/current-user])
            current-account @(re-frame/subscribe [::subs/current-account])]
        [:div
         [keyboard-shortcuts/keyboard-shortcuts-provider
          [navigation-layout
           [application-provider
            [router/get-view current-route]]
           {:user-projects          user-projects
            :user-accounts          user-accounts
            :current-project        current-project
            :current-user           current-user
            :current-account        current-account
            :system-messages        @(re-frame/subscribe [::subs/system-messages])
            :on-hide-system-message (partial-dispatch [::events/hide-system-message])
            :on-project-pin-clicked (partial-dispatch [::events/project-pin])
            :target-account         (:target-account options)
            :target-user-accounts   (:target-user-accounts options)}]]
         [license-modal/license-blocked-modal]
         [view-editor/view-editor-modal]
         [batch-modal/batch-modal]
         [find-and-replace-modal/find-and-replace-modal]
         [version-updates/version-update-handler]
         [impersonation/impersonation-modal]]))))

(defn ^:dev/after-load mount-root []
  ;; Only remount if there's a route - otherwise messes up with rails UI in dev mode
  (when (router/get-current-route)
    (rdom/render [main-view]
                 (js/document.getElementById "main"))))

;; Legacy ruby `flash` object support
(defn process-ruby-flash [flash]
  (doseq [[key message] flash]
    ;; We handle only 'error' and 'success' keys here for now
    (let [msg (try
                ;; try to parse JSON string
                (when (string? message)
                  ; for when passed from backend like: flash[:error] = { message: err.html_safe, status: 'error', raw_html?: true }.to_json
                  (js->clj (js/JSON.parse message) :keywordize-keys true))
                ;; catch JSON parse errors
                (catch js/Error e
                  ; if parsing fails, treat message as a plain string
                  ; this is for when passed from backend like: flash[:error] = err.html_safe
                  {:message message}))]
      (cond
        (= key "success")
        (re-frame/dispatch [::notifications/success2 (:message msg) {:raw-html? (:raw_html? msg)}])

        (= key "error")
        (re-frame/dispatch [::notifications/error2 (:message msg) {:raw-html? (:raw_html? msg)}])))))

(defn ^:export init [options]
  (init/init! {:options options
               :init-event-fn (fn [config]
                                [::events/initialize-db config nil nil])})
  (js/goog.exportSymbol "practitest" (or (.-practitest js/window) (js-obj)))
  (js/goog.exportSymbol "practitest.frontend" (or (.. js/window -practitest -frontend) (js-obj)))

  (process-ruby-flash (js->clj (gobj/get options "flash")))

  ;; Always init UI here, even if we don't have route, otherwise user will see a blank screen
  (rdom/render [main-view]
               (js/document.getElementById "main")))

(comment
  (tap> (re-frame/subscribe [::subs/system-messages]))
  )
